module.exports = __webpack_public_path__ + "media/fanfare.917be93a.mp3";